// frontend/src/components/announcements/AnnouncementsPage.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import AnnouncementList from "./AnnouncementList";
import CreateAnnouncementForm from "./CreateAnnouncementForm";
import EditAnnouncementForm from "./EditAnnouncementForm";
import "./announcements.css";

const AnnouncementsPage = () => {
  const { user } = useAuth();

  if (!user?.is_primary) {
    return (
      <div className="alert alert-danger">
        <i className="bi bi-exclamation-triangle-fill me-2"></i>
        <strong>Access Denied:</strong> This feature is only available to the
        primary tenant administrator.
      </div>
    );
  }

  return (
    <div className="container mt-4 px-3 px-md-4 px-lg-5">
      <Routes>
        <Route index element={<AnnouncementList />} />
        <Route path="create" element={<CreateAnnouncementForm />} />
        <Route path="edit/:id" element={<EditAnnouncementForm />} />
        <Route
          path="*"
          element={<Navigate to="/crm/announcements" replace />}
        />
      </Routes>
    </div>
  );
};

export default AnnouncementsPage;
